module.exports = __webpack_public_path__ + "static/scale-model-of-gum-wall-in-seattle-washington-ab665816eb2417eea4e633a862ca4d33.png";